import moment from "moment/moment";

export interface Signataire {
  id: number;
  prenom?: string;
  nom?: string;
  mail?: string;
  status?: string | null;
  // Uniquement dans la réponse de /oodrive/<id>/my-signature-links (le lien des autres signataires n'est jamais exposé)
  link?: string | null;
}

export interface DocumentFile {
  id: number;
  tag: string;
  filename?: string;
  mimetype?: string;
  shared?: boolean;
  status?: number | string;
  date_add?: string;
  signature_electronique_status?: string | number | null;
  signataires?: Signataire[];
  id_laposte?: number | null;
  id_tenant?: number | null;
  id_bien?: number | null;
  id_property_folder?: number | null;
  valid_until?: string;
  meta?: {
    date_quittance?: string;
    /** Autres diagnostics regroupés dans ce PDF (tags). */
    diagnostics?: string[];
  } & Record<string, unknown>;
}

export type ExpirationStatus = "expired" | "expiring" | null;

/** Même seuil que le back : une action prioritaire s'ouvre à 2 mois de l'expiration. */
export function getExpirationStatus(
  validUntil?: string | null,
): ExpirationStatus {
  if (!validUntil) {
    return null;
  }
  if (moment(validUntil).isBefore(moment(), "day")) {
    return "expired";
  }
  if (moment(validUntil).isSameOrBefore(moment().add(2, "months"), "day")) {
    return "expiring";
  }
  return null;
}

/** Statut d'expiration du document le plus récent d'un groupe (max des valid_until). */
export function getGroupExpirationStatus(
  files: DocumentFile[],
): ExpirationStatus {
  const dates = files
    .map((file) => file.valid_until)
    .filter((date): date is string => Boolean(date));
  if (!dates.length) {
    return null;
  }
  return getExpirationStatus(
    dates.reduce((latest, date) => (date > latest ? date : latest)),
  );
}
